import React, { useEffect, useState, useRef } from "react"; // useRef ekledik
import { API_BASE } from "../../config";

export default function MenuModal({ open, onClose }) {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [err, setErr] = useState("");
    const [categories, setCategories] = useState([]);
    const [activeCat, setActiveCat] = useState(null);

    // Sürükleme için referans ve state'ler
    const scrollRef = useRef(null);
    const [isDown, setIsDown] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeftState, setScrollLeftState] = useState(0);

    // ESC + scroll kilidi (Aynen bıraktım)
    useEffect(() => {
        if (!open) return;
        const onKeyDown = (e) => { if (e.key === "Escape") onClose?.(); };
        document.addEventListener("keydown", onKeyDown);
        document.body.style.overflow = "hidden";
        return () => {
            document.removeEventListener("keydown", onKeyDown);
            document.body.style.overflow = "";
        };
    }, [open, onClose]);

    // Veri çekme (Aynen bıraktım)
    useEffect(() => {
        // Sadece modal AÇIKSA ve daha önce VERİ YÜKLENMEMİŞSE istek at
        if (open && categories.length === 0) {
            const load = async () => {
                setLoading(true);
                try {
                    const [catsRes, prodRes] = await Promise.all([
                        fetch(`${API_BASE}/api/categories`),
                        fetch(`${API_BASE}/api/products`),
                    ]);

                    const cats = await catsRes.json();
                    const prods = await prodRes.json();

                    const catArr = Array.isArray(cats) ? cats : [];
                    setCategories(catArr);

                    if (catArr.length > 0) {
                        setActiveCat(catArr[0].id);
                    }

                    setItems(Array.isArray(prods) ? prods : []);
                } catch (e) {
                    setErr("Veriler yüklenemedi.");
                } finally {
                    setLoading(false);
                }
            };
            load();
        }
    }, [open, categories.length]);

    // SÜRÜKLEME FONKSİYONLARI
    const handleMouseDown = (e) => {
        setIsDown(true);
        // Mouse'un tıkladığı yer ile scroll konumu arasındaki farkı al
        setStartX(e.pageX - scrollRef.current.offsetLeft);
        setScrollLeftState(scrollRef.current.scrollLeft);
    };

    const handleMouseLeaveOrUp = () => {
        setIsDown(false);
    };

    const handleMouseMove = (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - scrollRef.current.offsetLeft;
        const walk = (x - startX) * 2; // Kaydırma hızı (2 idealdir)
        scrollRef.current.scrollLeft = scrollLeftState - walk;
    };

    if (!open) return null;

    const stop = (e) => e.stopPropagation();
    const filtered = activeCat
        ? items.filter((p) => p.categoryId === Number(activeCat))
        : [];

    return (
        <div className="menuModalOverlay" onClick={onClose} role="dialog" aria-modal="true">
            <div className="menuModal" onClick={stop}>
                <div className="menuModalHeader">
                    <div className="menuModalTitle">Menü</div>
                    <button className="menuModalClose" onClick={onClose}>✕</button>
                </div>

                <div className="menuModalBody">
                    {/* SÜRÜKLENEBİLİR ALAN */}
                    <div
                        className="menuTabsWrapper"
                        ref={scrollRef}
                        onMouseDown={handleMouseDown}
                        onMouseLeave={handleMouseLeaveOrUp}
                        onMouseUp={handleMouseLeaveOrUp}
                        onMouseMove={handleMouseMove}
                        style={{ cursor: isDown ? 'grabbing' : 'grab' }}
                    >
                        <div className="menuTabs">
                            {categories.map((c) => (
                                <button
                                    key={c.id}
                                    className={`menuTab ${Number(activeCat) === c.id ? "isActive" : ""}`}
                                    onClick={() => setActiveCat(c.id)}
                                >
                                    {c.name}
                                </button>
                            ))}
                        </div>
                    </div>

                    {loading ? (
                        <div className="menuEmpty">Yükleniyor...</div>
                    ) : err ? (
                        <div className="menuEmpty">{err}</div>
                    ) : items.length === 0 ? (
                        <div className="menuEmpty">Henüz ürün eklenmemiş.</div>
                    ) : (
                        <div className="menuList">
                            {filtered.map((p) => (
                                <div className="menuRow" key={p.id}>
                                    <div className="menuThumb">
                                        {p.imageUrl ? (
                                            <img src={`${API_BASE}${p.imageUrl}`} alt={p.name} />
                                        ) : (
                                            <div className="menuThumbPlaceholder">
                                                {p.name?.slice(0, 1)?.toUpperCase()}
                                            </div>
                                        )}
                                    </div>
                                    <div className="menuInfo">
                                        <div className="menuName">{p.name}</div>
                                        {p.description && <div className="menuDesc">{p.description}</div>}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                <div className="menuModalFooter">
                    <button className="menuModalBtn" onClick={onClose}>Kapat</button>
                </div>
            </div>
        </div>
    );
}